import { render, staticRenderFns } from "./RuangTamu.vue?vue&type=template&id=64c48f4e&"
import script from "./RuangTamu.vue?vue&type=script&lang=js&"
export * from "./RuangTamu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports